import { Component, Input, ViewChildren, QueryList } from '@angular/core';
import { Router } from '@angular/router';
import { BenefitsService } from 'src/app/services/api/benefits/benefits.service';
import { SwiperComponent } from 'swiper/angular';
import SwiperCore, { Virtual, SwiperOptions, Pagination } from 'swiper';

SwiperCore.use([Virtual, Pagination]);

@Component({
  selector: 'app-benefits-item',
  templateUrl: './benefits-item.component.html',
  styleUrls: ['./benefits-item.component.scss'],
})
export class BenefitsItemComponent {
  @ViewChildren('swiperDesktop') swiperDesktop!: QueryList<SwiperComponent>;
  @ViewChildren('swiperMobile') swiperMobile!: QueryList<SwiperComponent>;
  @Input() benefit: any[] = [];
  @Input() redeemCodes: boolean;
  @Input() dashboard: boolean;
  @Input() seeAll: boolean;
  @Input() customTitle: string;
  @Input() bothTypes: boolean = false;
  currentSlideIndex: number = 0;
  public isEnd: boolean = false;

  benefitsSlider: SwiperOptions = {
    spaceBetween: 15 * 1.5,
    width: 1000,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    pagination: {
      type: 'bullets',
      dynamicBullets: true,
      clickable: true
    },
    rewind: true,
    initialSlide: 0,
    breakpoints: {
      1550: {
        slidesPerView: 4.7,
      },
      1370: {
        slidesPerView: 4.4,
      },
      1215: {
        slidesPerView: 4,
      },
      1080: {
        slidesPerView: 3.8,
      },
      1000: {
        slidesPerView: 3.4,
      },
    },
  };

  noRedeemCodesSlider: SwiperOptions = {
    width: 1000,
    spaceBetween: 0,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    pagination: {
      type: 'bullets',
      dynamicBullets: true,
      clickable: true
    },
    rewind: true,
    initialSlide: 0,
    breakpoints: {
      1550: {
        spaceBetween: 20 * 3.5,
        slidesPerView: 3.2,
      },
      1370: {
        spaceBetween: 0,
        slidesPerView: 2.9,
      },
      1215: {
        spaceBetween: 20 * 3.5,
        slidesPerView: 2.6,
      },
      1080: {
        spaceBetween: 20 * 3.5,
        slidesPerView: 2.3,
      },
      1000: {
        spaceBetween: 0,
        slidesPerView: 1.5,
      },
    },
  };

  configDraw: SwiperOptions = {
    loop: true,
    autoplay: true,
    initialSlide: 1,
    slidesPerView: 1.1,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    pagination: {
      type: 'bullets',
      dynamicBullets: true,
      clickable: true
    },
    preventClicksPropagation: false,
    speed: 600,
    centeredSlides: true,
    spaceBetween: 10,
    breakpoints: {
      1280:{
        slidesPerView: 1.12,
      }
    },
    loopAdditionalSlides: 4,
    simulateTouch: true,
  };

  benefitsSliderMobile: SwiperOptions = {
    autoplay: {
      delay: 3000,
      disableOnInteraction: false,
    },
    pagination: {
      type: 'bullets',
      dynamicBullets: true,
      clickable: true
    },
    loop: true,
    preventClicksPropagation: false,
    speed: 600,
    spaceBetween: 10,
    loopAdditionalSlides: 4,
    initialSlide: 0,
    slidesPerView: 1.5,
    breakpoints: {
      800: {
        slidesPerView: 2.8,
      },
      700: {
        slidesPerView: 2.4,
      },
      450: {
        slidesPerView: 1.6,
      },
    },
  };

  noRedeemCodesSliderMobile: SwiperOptions = {
    autoplay: {
      delay: 3000,
      disableOnInteraction: false,
    },
    pagination: {
      type: 'bullets',
      dynamicBullets: true,
      clickable: true
    },
    loop: true,
    preventClicksPropagation: false,
    speed: 600,
    spaceBetween: 5,
    loopAdditionalSlides: 40,
    initialSlide: 0,
    slidesPerView: 1.2,
    breakpoints: {
      800: {
        slidesPerView: 2.4,
      },
      700: {
        slidesPerView: 2,
      },
      480: {
        slidesPerView: 1.6,
      },
    },
  };

  constructor(
    private benefitsService: BenefitsService,
    private router: Router,
  ) {}

  getCurrentDay(): string {
    const today = new Date().getDay().toString();
    return today === '0' ? '7' : today;  
  }

  shouldApplyBackgroundClass(benefits: any[]): boolean {
    return benefits.some(benefit => benefit?.benefit?.redeemCodes === true);
  }
  
  getSliderConfig(benefits: any[]): SwiperOptions {
    const total = benefits.length;
    const redeemCodesCount = benefits.filter(b => b?.benefit?.redeemCodes === true).length;
    const noRedeemCodesCount = benefits.filter(b => b?.benefit?.redeemCodes === false).length;
    this.bothTypes = redeemCodesCount > 0 && noRedeemCodesCount > 0;
    if (redeemCodesCount / total >= 0.5) {
      return this.benefitsSlider;
    }
    return this.noRedeemCodesSlider;
  }

  getSliderConfigMobile(benefits: any[]): SwiperOptions {
    const total = benefits.length;
    const redeemCodesCount = benefits.filter(b => b?.benefit?.redeemCodes === true).length;
    const noRedeemCodesCount = benefits.filter(b => b?.benefit?.redeemCodes === false).length;
    this.bothTypes = redeemCodesCount > 0 && noRedeemCodesCount > 0;

    if (redeemCodesCount / total >= 0.5) {
      return this.benefitsSliderMobile;
    }
    return this.noRedeemCodesSliderMobile;
  }

  slideNext(index: number = 0): void {
    const swiper = this.swiperDesktop.toArray()[index]?.swiperRef;
    if (swiper) {
      swiper.slideNext(100);
      this.currentSlideIndex = swiper.realIndex;
      this.isEnd = swiper?.isEnd || false;
    }
  
  }

  
  slidePrev(index: number = 0): void {
    const swiper = this.swiperDesktop.toArray()[index]?.swiperRef;
    if (swiper) {
      swiper.slidePrev(100);
      this.currentSlideIndex = swiper.realIndex;
      this.isEnd = swiper?.isEnd || false;
    }
  }
  
  slideNextMobile(index: number = 0): void {
    const swiper = this.swiperMobile.toArray()[index]?.swiperRef;
    swiper?.slideNext(100);
  }
  
  slidePrevMobile(index: number = 0): void {
    const swiper = this.swiperMobile.toArray()[index]?.swiperRef;
    swiper?.slidePrev(100);
  }  

  benefitDetail(benefit: any): void {
    const url = this.benefitsService.getBenefitUrl(benefit);
    this.router.navigateByUrl(url);
  }
}
